module.exports = __webpack_public_path__ + "img/4.bb07d9b1.png";